module.exports = __webpack_public_path__ + "img/kx1.a775d966.png";